import { useState, type FormEvent } from 'react';
import {
  Button,
  DialogActions,
  DialogContent,
  TextField,
} from '@mui/material';
import { ADMIN_PAGE_LABELS as LABELS  } from '../../../utils/labels';
import AppDialog from '../../../components/AppDialog';
import { useModalHistory } from '../../../utils/useModalHistory';
import SpinnerButton from '../../../components/SpinnerButton';

interface CreateOrgModalProps {
  onClose: () => void;
  onSave: (name: string) => Promise<boolean>;
}

export default function CreateOrgModal({ onClose, onSave }: CreateOrgModalProps) {
  useModalHistory(onClose);
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      setNameError(LABELS.nameRequired);
      return;
    }
    setSaving(true);
    const ok = await onSave(name.trim());
    setSaving(false);
    if (ok) onClose();
  };

  return (
    <AppDialog open onClose={onClose} maxWidth="xs" fullWidth title={LABELS.newOrgTitle} confirmLabel={LABELS.createButton} confirmFormId="create-org-form" confirmDisabled={saving} confirmLoading={saving} testId="create-org-modal">
      <form id="create-org-form" onSubmit={handleSubmit} noValidate>

        <DialogContent>
          <TextField
            label={LABELS.newOrgNameLabel}
            value={name}
            onChange={(e) => { setName(e.target.value); if (nameError) setNameError(''); }}
            required
            autoFocus
            fullWidth
            className="mt-2"
            error={!!nameError}
            helperText={nameError || undefined}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="inherit">{LABELS.cancel}</Button>
          <SpinnerButton type="submit" variant="contained" loading={saving}>
            {LABELS.createButton}
          </SpinnerButton>
        </DialogActions>
      </form>
    </AppDialog>
  );
}
